import FileHelper from './file-helper';

export default class ImageHelper extends FileHelper {
    constructor (limitTypes = [], limitSize = null, limitWidth = null, limitHeight = null) {
        super(limitTypes, limitSize);
        this.limitWidth = limitWidth;
        this.limitHeight = limitHeight;
        this.validators.push(this.isWidthValid, this.isHeightValid);
        // 为了检测宽高而设定的 imageLoaded 值（ 因为宽高检测需要 load 过程，为避免重复耗时，故而使用该机制 ）需要在检测后重置
        // 以免第二次检测时发生干扰
        this.aftermathFunctions.push(this.resetImageLoadedStatus);
        this.image = null;
        this.imageLoaded = false;
    }

    isWidthValid = async (file) => {
        if (null === this.limitWidth) return true;
        await this.load(file);

        const width = this.image.width;
        if (this.limitWidth !== width) {
            this.addErrorMessage(`图片宽度不符合要求：需要 ${this.limitWidth}，实际为 ${width}`);
            return false;
        } else {
            return true;
        }
    };

    isHeightValid = async (file) => {
        if (null === this.limitHeight) return true;
        await this.load(file);

        const height = this.image.height;
        if (this.limitHeight !== height) {
            this.addErrorMessage(`图片高度不符合要求：需要 ${this.limitHeight}，实际为 ${height}`);
            return false;
        } else {
            return true;
        }
    };

    load (file) {
        return new Promise((resolver, reject) => {
            if (this.imageLoaded) return resolver();

            const imageData = URL.createObjectURL(file);
            this.image = new Image();
            this.image.src = imageData;
            this.image.onload = () => {
                this.imageLoaded = true;
                resolver();
            };
        });
    }

    resetImageLoadedStatus = () => {
        this.imageLoaded = false;
    }
}
